import React, { useState, useEffect } from 'react';
import { employeeService } from '../../services/employeeService';

const EmploymentDetailsCard = ({ employeeUuid }) => {
  const [assignment, setAssignment] = useState(null);
  const [departmentName, setDepartmentName] = useState('Loading...');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // 1. Assignment fetch karo
        const orgRes = await employeeService.getEmployeeOrganisationAssignments(employeeUuid);
        const primary = orgRes.data?.[0] || null;
        setAssignment(primary);

        // 2. Agar assignment mil gaya, toh Departments ki list fetch karke name map karo
        if (primary && primary.department_uuid) {
          const deptRes = await employeeService.getDepartments();
          const dept = deptRes.data?.find(d => d.uuid === primary.department_uuid);
          setDepartmentName(dept ? dept.department_name : 'Unknown Department');
        } else {
          setDepartmentName('N/A');
        }
      } catch (err) {
        console.error('Failed to load employment data', err);
        setDepartmentName('Error');
      } finally {
        setLoading(false);
      }
    };

    if (employeeUuid) fetchData();
  }, [employeeUuid]);

  if (loading) return <div className="p-6 bg-white shadow-md rounded-lg text-sm text-gray-500">Loading Employment Details...</div>;

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">Employment & Organisation</h3>
      
      {!assignment ? (
        <p className="text-sm text-gray-500">No assignment details available.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
          <div className="space-y-3">
            <p><span className="font-medium text-gray-500">Employment Type:</span> <span className="text-gray-800 capitalize">{assignment.employment_type}</span></p>
            <p><span className="font-medium text-gray-500">Status:</span> <span className="text-gray-800 capitalize">{assignment.status}</span></p>
            <p><span className="font-medium text-gray-500">Allocation:</span> <span className="text-gray-800">{assignment.allocation_percentage}%</span></p>
          </div>
          
          <div className="space-y-3">
            <p><span className="font-medium text-gray-500">Effective From:</span> <span className="text-gray-800">{assignment.effective_from}</span></p>
            <p><span className="font-medium text-gray-500">Department:</span> <span className="text-gray-800 font-semibold">{departmentName}</span></p>
            {/* Yahan designation ki API mil jaye toh same tarike se map kar lena */}
          </div>
        </div>
      )}
    </div>
  );
};

export default EmploymentDetailsCard;